import { render } from "./Broadcaster.vue?vue&type=template&id=b3574ac8&scoped=true"
import script from "./Broadcaster.vue?vue&type=script&lang=js"
export * from "./Broadcaster.vue?vue&type=script&lang=js"

import "./Broadcaster.vue?vue&type=style&index=0&id=b3574ac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3574ac8"]])

export default __exports__